///
/// EarthBrowser
///
/// Created by Matt Giger on 1/29/2025
/// Copyright (c) 2025 Geodata Labs
///

export class Constants {
	public static readonly databaseName = "ebg"
	public static readonly volumeName = "eb_volumes"
	public static readonly persistStorageVersion = 24
	public static readonly baseStorageUrl = "https://b2.earthbrowser.com/file/earthbrowser"
	// Tile-server passthrough for the B2 datasets tree (see utils/datasetUrl.ts)
	public static readonly baseDataUrl = "https://tiles.earthbrowser.com/data"
	// Tile-server passthrough for the B2 static assets tree
	public static readonly baseStaticUrl = "https://tiles.earthbrowser.com/static"
	// Tile-server passthrough for bucket-root media (cloud/SST/IMERG/MRMS
	// frames, radar mosaics, NEXRAD atlases; see utils/datasetUrl.ts)
	public static readonly baseMediaUrl = "https://tiles.earthbrowser.com/media"
	// Tile-server passthrough for the ebpackages bucket (user-uploaded
	// datasets, GeoPackages, avatars; see utils/datasetUrl.ts)
	public static readonly basePackagesUrl = "https://tiles.earthbrowser.com/packages"
	public static readonly baseFlagUrl = `${Constants.baseStaticUrl}/images/flags`

	// Camera constants
	public static readonly cMaxCameraAltitude = 50_000	// kilometers
	public static readonly cDefaultCameraAltitude = 20_000 // kilometers
	public static readonly cMinCameraAltitude = 10	// kilometers
}
